import submit from '@mailobj-browser/front/js/events/types/submit.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { fromEvent } from '#utilities/js/ea/ajax.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import alert from '#utilities/js/ea/alert.js'
import * as generics from '#components/generics/js/styles.js'
import { close } from '#utilities/js/lightboxes/lightbox.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onSubmit = object(listener, {
  type: submit,
  passive,
  task: async (
    modalForm,
    event
  ) => {
    const { dataset } = modalForm
    const { alert: msgAlert } = dataset
    const tabs = one(`.${generics.elements.tabs}`, modalForm)

    if (tabs) {
      const tabsNav = one(`.${generics.elements.tabs_navigation}`, tabs)
      if (tabsNav) {
        const navTargetAnchor = one(`.${generics.modifiers.button.active}`, tabsNav)

        if (navTargetAnchor) {
          const { dataset: navDataset } = navTargetAnchor

          if (navDataset) {
            const { target: navName } = navDataset

            if (navName) {
              const navTarget = navName.slice(navName.indexOf('_') + 1, navName.length)

              if (navTarget) {
                const adbookList = one(`.${generics.elements.tab_panel}[data-tab="${navTarget}"]`, tabs)

                if (adbookList) {
                  const tabCheckboxes = all(`.${generics.modifiers.new_field_input.new_checkbox}`, adbookList)

                  if (tabCheckboxes) {
                    let ok = false

                    for (const checkbox of tabCheckboxes) {
                      if (checkbox.checked && checkbox.disabled === false) {
                        ok = true
                      }
                    }

                    if (ok) {
                      await fromEvent(modalForm, event)
                      close()
                    } else {
                      await alert(msgAlert)
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
})

export default (adbookForm) => {
  onSubmit.listen(adbookForm)
}
